var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.932 1.167a3.944 3.944 0 1 0 0 7.889 3.944 3.944 0 0 0 0-7.89ZM.987 5.11a4.944 4.944 0 1 1 9.89 0 4.944 4.944 0 0 1-9.89 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.838 8.017a.5.5 0 0 1 .707 0l2.963 2.963a.5.5 0 1 1-.707.707L8.838 8.724a.5.5 0 0 1 0-.707",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.813 7.279a.5.5 0 0 1 .469.529c-.026.443-.115.873-.433 1.188-.309.306-.742.41-1.192.463a.5.5 0 1 1-.119-.992c.417-.05.552-.127.607-.181.046-.045.116-.156.139-.538a.5.5 0 0 1 .529-.47Z",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;